import Vue from 'vue'
import App from './App.vue'
//import './registerServiceWorker'
import router from './router'
import store from './store'
import './plugins/bootstrap-vue'
import i18n from './plugins/i18n'
import './plugins/toasted'
import './mixins/common'
import './plugins/moment'
import './plugins/drawerLayout'
import './plugins/vueEvents'
import './plugins/axios'
import './plugins/veevalidate'
import './plugins/commonLists'


import commonDataPlugin from './plugins/commonDataPlugin';
Vue.use(commonDataPlugin);

// permissions plugin
import permissionsPlugin from './plugins/permissionsPlugin'
Vue.use(permissionsPlugin);

import { DatePickerPlugin, TimePickerPlugin, DateTimePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import { ContextMenuPlugin } from '@syncfusion/ej2-vue-navigations';




    

import { L10n, setCulture, enableRtl, loadCldr } from '@syncfusion/ej2-base';


setCulture('ar');


L10n.load({
    'ar': {
        "calendar": {
            "today": "اليوم"
        },
        "datepicker": {
            "today": "اليوم",
            "placeholder": ""
        },
        "timepicker": {
            "placeholder": ""
        },
        "datetimepicker": {
            "today": "اليوم",
            "placeholder": ""
        },
    }
});





//import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
//import * as gregorian from 'cldr-data/main/ar/ca-gregorian.json';
//import * as ca_islamic from 'cldr-data/main/ar-SA/ca-islamic.json';
//import * as numbers from 'cldr-data/main/ar/numbers.json';
//import * as timeZoneNames from 'cldr-data/main/ar/timeZoneNames.json';
//import * as weekData from "cldr-data/supplemental/weekData.json";

//console.log(numbers);

////loadCldr(numberingSystems, gregorian, numbers, timeZoneNames);
//loadCldr(numberingSystems);
//loadCldr(gregorian);
////loadCldr(ca_islamic);
//loadCldr(numbers);
//loadCldr(timeZoneNames);
//loadCldr(weekData);

loadCldr(
    require('cldr-data/supplemental/numberingSystems.json'),
    require('cldr-data/main/ar/ca-gregorian.json'),
    require('cldr-data/main/ar/numbers.json'),
    require('cldr-data/main/ar/timeZoneNames.json'),
    require('cldr-data/supplemental/weekData.json') // To load the culture based first day of week
);


Vue.use(DatePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(ContextMenuPlugin);


import { ChartPlugin } from '@syncfusion/ej2-vue-charts';
Vue.use(ChartPlugin);

import { CalendarPlugin } from "@syncfusion/ej2-vue-calendars";
Vue.use(CalendarPlugin);

Vue.config.productionTip = true;



import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr';


Vue.prototype.$appsHub = new HubConnectionBuilder()
    .withUrl('/appshub')
    .configureLogging(LogLevel.Information)
    .build()



Vue.filter('abs', function (value) {
    if (!value) return ''
    return Math.abs(value);
})



new Vue({
  router,
    store,
  i18n,
  render: h => h(App)
}).$mount('#app')
